import apiFn from 'common/services/api-service';

const api = eventId => apiFn(`/api/uapi/events/${eventId}/integrations`);

export function list(eventId, type = null) {
  return api(eventId)
    .get(null, {
      params: {
        type,
      },
    })
    .then(response => response?.data?.data);
}

export function get(eventId, integrationId) {
  return api(eventId)
    .get(integrationId)
    .then(response => response?.data?.data);
}

// Eventbrite Specific
export function getRemoteEvents(eventId, integrationId) {
  return api(eventId)
    .get(`${integrationId}/remote_events/`)
    .then(response => response?.data?.data);
}

export function update(eventId, integrationId, data) {
  return api(eventId)
    .patch(integrationId, data)
    .then(response => response?.data?.data);
}

export function resync(eventId, integrationId) {
  return api(eventId)
    .post(`${integrationId}/sync/`)
    .then(response => response?.data?.data);
}

export function disconnect(eventId, integrationId) {
  return api(eventId)
    .delete(integrationId)
    .then(response => response?.data?.data);
}

export const LOCAL_STORAGE_EVENT_ID_KEY = 'integration-oauth-event-id';

export const getInternalEventId = (global = window) =>
  global.localStorage.getItem(LOCAL_STORAGE_EVENT_ID_KEY);

export const setInternalEventId = (eventId, global = window) => {
  global.localStorage.setItem(LOCAL_STORAGE_EVENT_ID_KEY, String(eventId));
};

// Opens the oAuth URL in new tab and looks for the changes after each N number
// of milliseconds which can be provided as `frequency`.
//
// Note: if there's no value provided as `frequency`, it will look for the tab
// to be closed after one second.
export function connect(eventId, url, global = window, frequency = 1000) {
  return new Promise((resolve, reject) => {
    if (url.length === 0) {
      reject(new Error('invalid URL for Integration'));
    }

    setInternalEventId(eventId, global);
    const tab = global.open(url, '_blank');

    tab.focus();

    /* eslint-disable prefer-const -- avoid TDZ when callback fires synchronously */
    let intervalId;
    intervalId = global.setInterval(() => {
      if (tab.closed) {
        global.clearInterval(intervalId);
        resolve();
      }
    }, frequency);
    /* eslint-enable prefer-const */
  });
}

export function zoomList(eventId, type) {
  return api(eventId)
    .get(`zoom/${type}`)
    .then(response => response?.data?.data);
}

export function zoomDetails(eventId, type, id) {
  return api(eventId)
    .get(`zoom/${type}/${id}`)
    .then(response => response?.data?.data);
}
